/*
 * File: d:\projects\AutoFiFront\src\Content\Login\Login.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday January 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday January 13th 2023 2:10:45 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import styles from "Content/Login/Login.module.css";
import translator from "MultiLanguage/TranslationWrapper";
import { useLocation } from 'react-router-dom';
import { useMemo } from "react";
import FormLogin from "./Form/FormLogin";
import { Link } from "react-router-dom";
import RouterPathResolver from "Config/Router/RouterPathResolver";

function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
};

function Login() {
    const query = useQuery();

    return(
        <div className={`${styles.loginForm}`}>
            <p className="font-weight-700 small-font-2">{translator.decode("login.title")}</p>
            <FormLogin returnUrl={query.get("return_url")} />
            <Link to={RouterPathResolver.routeSignIn.path}>{translator.decode("dynamic.createAccount")}</Link>
            <Link to={RouterPathResolver.routeForgotPassword.path}>{translator.decode("login.forgotpassword")}</Link>
        </div>
    );
}

export default Login;
